import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        primary: { main: '#28766B', dark: '#1D5A51', light: '#E7F2EF', contrastText: '#FFFFFF' },
        secondary: { main: '#9A4545' },
        success: { main: '#39764C' },
        warning: { main: '#996322' },
        background: { default: '#F6F7F3', paper: '#FFFFFF' },
        text: { primary: '#253B36', secondary: '#5F706A' },
        action: { hover: 'rgba(40,118,107,0.045)', selected: 'rgba(40,118,107,0.09)' },
        divider: '#E3E8E2',
    },
    shape: { borderRadius: 8 },
    typography: {
        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        h1: { fontSize: '2.25rem', fontWeight: 650, letterSpacing: '-0.045em' },
        h3: { fontSize: '2.5rem', fontWeight: 650, letterSpacing: '-0.04em' },
        h4: { fontSize: '1.9rem', fontWeight: 650, letterSpacing: '-0.035em' },
        h5: { fontSize: '1.3rem', fontWeight: 600, letterSpacing: '-0.02em' },
        h6: { fontSize: '1.05rem', fontWeight: 650, letterSpacing: '-0.015em' },
        body1: { lineHeight: 1.6 },
        body2: { lineHeight: 1.55 },
        button: { textTransform: 'none', fontWeight: 600, letterSpacing: 0 },
    },
    components: {
        MuiCssBaseline: { styleOverrides: {
            '*': { boxSizing: 'border-box' },
            body: { WebkitFontSmoothing: 'antialiased' },
            ':focus-visible': { outline: '3px solid #28766B', outlineOffset: 3 },
            '@media (prefers-reduced-motion: reduce)': {
                '*, *::before, *::after': { animationDuration: '0.01ms !important', transitionDuration: '0.01ms !important', scrollBehavior: 'auto !important' },
            },
        } },
        MuiPaper: { styleOverrides: { outlined: { borderColor: '#E3E8E2', backgroundImage: 'none' } } },
        MuiCard: { styleOverrides: { root: { borderRadius: 12, boxShadow: 'none' } } },
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: { root: { borderRadius: 8, minHeight: 40, paddingLeft: 16, paddingRight: 16, transition: 'background-color 160ms ease, border-color 160ms ease' }, outlined: { borderColor: '#B7CDC5' } },
        },
        MuiIconButton: { styleOverrides: { root: { minWidth: 40, minHeight: 40 } } },
        MuiDialog: { styleOverrides: { paper: { borderRadius: 18, backgroundImage: 'none' } } },
        MuiDialogTitle: { styleOverrides: { root: { fontWeight: 650, padding: '24px 24px 16px' } } },
        MuiAlert: { styleOverrides: { root: { borderRadius: 10 } } },
        MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 9, backgroundColor: '#FFFFFF' }, notchedOutline: { borderColor: '#CDD7D0' } } },
        MuiMenu: { styleOverrides: { paper: { borderRadius: 12, border: '1px solid #E3E8E2', boxShadow: '0 8px 32px rgba(30,56,45,0.10)' } } },
        MuiAppBar: { defaultProps: { elevation: 0, color: 'inherit' }, styleOverrides: { root: { backgroundColor: '#FFFFFF', borderBottom: '1px solid #E3E8E2' } } },
        MuiTabs: { styleOverrides: { indicator: { height: 3, borderRadius: '3px 3px 0 0' } } },
        MuiTab: { styleOverrides: { root: { minHeight: 46, paddingLeft: 16, paddingRight: 16, fontSize: '0.875rem' } } },
        MuiToggleButtonGroup: { styleOverrides: { root: { padding: 4, gap: 4, backgroundColor: '#EDF1EC', borderRadius: 10, '& .MuiToggleButtonGroup-grouped': { border: 0, borderRadius: '7px !important' } } } },
        MuiToggleButton: { styleOverrides: { root: { minHeight: 36, padding: '6px 12px', color: '#5F706A', '&.Mui-selected': { color: '#1D5A51', backgroundColor: '#FFFFFF', boxShadow: '0 1px 4px rgba(37,59,54,0.09)', '&:hover': { backgroundColor: '#FFFFFF' } } } } },
        MuiTableCell: { styleOverrides: { root: { borderColor: '#E3E8E2', padding: '13px 16px', fontSize: '0.875rem' }, head: { backgroundColor: '#F3F6F2', color: '#5F706A', fontWeight: 650, whiteSpace: 'nowrap' } } },
        MuiLinearProgress: { styleOverrides: { root: { backgroundColor: '#E7EEE8' } } },
        MuiTooltip: { defaultProps: { arrow: true } },
    },
});
